(function() {
  var COOKIE_NAME = 'cbn_ref';
  var COOKIE_DAYS = 30;
  var APP_URL = 'https://cbn.pim-hub.com';
  var SESSION_FLAG = 'cbn_discount_applied';

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  }

  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  function getParam(key) {
    var params = new URLSearchParams(window.location.search);
    return params.get(key);
  }

  function addCartAttribute(code) {
    if (typeof Shopify === 'undefined' || !Shopify.routes) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { referral_code: code } })
    }).catch(function() {});
  }

  /* referral_code is a cart NOTE ATTRIBUTE -- it only feeds our own
     orders/paid webhook for commission attribution and has no effect on the
     price Shopify computes at checkout. Visiting /discount/<code> is
     Shopify's native way to actually apply a discount code to the session
     (same mechanism the stylist picker uses in cbn-cart-checkout.liquid).
     Gate on a sessionStorage flag so a returning visitor isn't redirected on
     every single page load for the full 30-day cookie window -- once per
     browser session is enough to keep the discount attached to the cart. */
  function discountAlreadyApplied() {
    try { return sessionStorage.getItem(SESSION_FLAG) === '1'; } catch (e) { return false; }
  }

  function applyDiscount(code) {
    if (discountAlreadyApplied()) return;
    if (typeof Shopify === 'undefined' || !Shopify.routes) return;
    try { sessionStorage.setItem(SESSION_FLAG, '1'); } catch (e) {}

    var params = new URLSearchParams(window.location.search);
    params.delete('ref');
    var qs = params.toString();
    var redirectTarget = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirectTarget);
  }

  function trackClick(code) {
    fetch(APP_URL + '/api/affiliate/track-click', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code: code, url: window.location.href })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      /* Only redirect through /discount/ once track-click confirms the code
         is a real, active AffiliateCode -- avoids sending visitors through a
         no-op discount redirect for a stale/mistyped ?ref= value. */
      if (data && data.ok) applyDiscount(code);
    })
    .catch(function() {});
  }

  var refCode = getParam('ref');
  if (refCode) {
    setCookie(COOKIE_NAME, refCode, COOKIE_DAYS);
    trackClick(refCode);
    addCartAttribute(refCode);
  } else {
    var cookieCode = getCookie(COOKIE_NAME);
    if (cookieCode) {
      addCartAttribute(cookieCode);
      applyDiscount(cookieCode);
    }
  }

  /* ── Franchise "location" attribution ──
     e.g. https://clubbeautynetwork.com/?location=texas -- a franchise's own
     link, unrelated to a stylist's ?ref= code. Also accepts the plural
     ?locations= (common typo/alias) as a fallback. No discount is applied here
     (this only credits the franchise a commission, it doesn't change price),
     so unlike ref/applyDiscount above there's no /discount/ redirect --
     just a cookie + a cart note attribute the orders/paid webhook reads
     (cbn_franchise_location), which ALWAYS takes precedence over any
     stylist attribution on the same order. */
  var LOC_COOKIE_NAME = 'cbn_franchise_loc';
  var LOC_COOKIE_DAYS = 30;

  function addLocationAttribute(code) {
    if (typeof Shopify === 'undefined' || !Shopify.routes) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { cbn_franchise_location: code } })
    }).catch(function() {});
  }

  function trackLocationClick(code) {
    fetch(APP_URL + '/api/affiliate/track-location-click', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ location: code, url: window.location.href })
    }).catch(function() {});
  }

  var locationCode = getParam('location') || getParam('locations');
  if (locationCode) {
    setCookie(LOC_COOKIE_NAME, locationCode, LOC_COOKIE_DAYS);
    trackLocationClick(locationCode);
    addLocationAttribute(locationCode);
  } else {
    var savedLocationCode = getCookie(LOC_COOKIE_NAME);
    if (savedLocationCode) addLocationAttribute(savedLocationCode);
  }
})();